import React from "react";
import { Close as X } from "@mui/icons-material";
import styles from "../AiImageGenerator.module.css";

export function Header({ onClose }) {
	return (
		<header className={styles.header}>
			<div>
				<h1 className={styles.title}>AI Image Editor</h1>
				<p className={styles.subtitle}>
					Powered by PhotoRoom — enhance an image or generate one from a prompt.
				</p>
			</div>
			{onClose && (
				<button
					type="button"
					onClick={onClose}
					aria-label="Close"
					className={styles.closeBtn}
				>
					<X sx={{ fontSize: 24 }} />
				</button>
			)}
		</header>
	);
}
